export const config = {
  excludedPaths: [
    '/fitting-type',
  ],
  appointmentsIds: [54616, 55366, 55370], // appointment id's to be consumed by ChildSelection[54616, 55366, 55370]; 1 child, 2 children, 3 children
};
